import {
    RESET_VARIABLE,
    GET_VARIABLE,
    SET_VARIABLE,
    API_ERROR_VARIABLE,
  } from "./actionTypes";
  
  const initialState = {
    data: null,
    loading: false,
    error: false,
  };
  
  const Variables = (state = initialState, action) => {
    switch (action.type) {
      case RESET_VARIABLE:
        state = initialState;
        break;
      case API_ERROR_VARIABLE:
        state = {
          ...state,
          error: action.payload,
          loading: false,
        };
        break;
     
      case GET_VARIABLE:
        state = {
          ...state,
          data: null,
          loading: true,
        };
        break;
      case SET_VARIABLE:
        state = {
          ...state,
          data: action.payload?.data,
          loading: false,
        };
        break;
      default:
        break;
    }
    return state;
  };
  
  export default Variables;
  